import { useMutation } from '@tanstack/react-query';

import { usePayoutApi } from '../api';
import { StoreItemHistoricalTransactionCountResponse } from './types';

type UpdateAccountCodeStoreItemProps = {
  causeId?: string;
  storeItemId?: string;
  accountCodeId?: string | null;
};

type UpdateAccountCodeProps = {
  causeId?: string;
  accountCodeId?: string | null;
  storeItemId?: string;
};

const useUpdateAccountCodeForStoreItem = () => {
  const PayoutApi = usePayoutApi();

  const updateAccountCode = async ({
    causeId,
    accountCodeId,
    storeItemId,
  }: UpdateAccountCodeStoreItemProps): Promise<StoreItemHistoricalTransactionCountResponse> => {
    const { data } = await PayoutApi.put(`/store_items/${storeItemId}`, {
      cause_id: causeId,
      account_code_id: accountCodeId,
    });
    return data;
  };

  return useMutation({
    mutationFn: updateAccountCode,
  });
};

const useUpdateAccountCodeForProductFundraiser = () => {
  const PayoutApi = usePayoutApi();

  const updateAccountCode = async ({
    causeId,
    accountCodeId,
  }: UpdateAccountCodeProps): Promise<StoreItemHistoricalTransactionCountResponse> => {
    const { data } = await PayoutApi.put(`/product_fundraisers`, {
      cause_id: causeId,
      account_code_id: accountCodeId,
    });
    return data;
  };

  return useMutation({
    mutationFn: updateAccountCode,
  });
};

const useUpdateAccountCodeForPos = () => {
  const PayoutApi = usePayoutApi();

  const updateAccountCode = async ({
    causeId,
    accountCodeId,
  }: UpdateAccountCodeProps): Promise<StoreItemHistoricalTransactionCountResponse> => {
    const { data } = await PayoutApi.put(`/pos`, {
      cause_id: causeId,
      account_code_id: accountCodeId,
    });
    return data;
  };

  return useMutation({
    mutationFn: updateAccountCode,
  });
};

const useUpdateAccountCodeForShopToGive = () => {
  const PayoutApi = usePayoutApi();

  const updateAccountCode = async ({
    causeId,
    accountCodeId,
  }: UpdateAccountCodeProps): Promise<StoreItemHistoricalTransactionCountResponse> => {
    const { data } = await PayoutApi.put(`/shop_to_give`, {
      cause_id: causeId,
      account_code_id: accountCodeId,
    });
    return data;
  };

  return useMutation({
    mutationFn: updateAccountCode,
  });
};

export {
  useUpdateAccountCodeForPos,
  useUpdateAccountCodeForProductFundraiser,
  useUpdateAccountCodeForShopToGive,
  useUpdateAccountCodeForStoreItem,
};
